class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {

    
  document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('search_tab_nav_button') || el.closest('.search_tab_nav_button')) {
      if(!el.classList.contains('search_tab_nav_button')) {
      	el = el.closest('.search_tab_nav_button');
      }
      e.preventDefault();

      const tabId = el.getAttribute('data-tab-id');

      const prevActiveTabNav = document.querySelector('.search_tab_nav_button.active');
      const prevActiveTab = document.querySelector('.search_tab_block.active');
      if(prevActiveTab) {
        prevActiveTab.classList.remove('active');
      }
      if(prevActiveTabNav) {
        prevActiveTabNav.classList.remove('active');
      }

      el.classList.add('active');
      document.querySelector('#'+tabId).classList.add('active');
    }
  });

    
    let allSearchForms = [];
    this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach(form =>
      form.addEventListener('reset', this.onFormReset.bind(this))
    );
    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({behavior: 'smooth'});
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
